;(function () {
  const vatLocalStorageKey = 'include-vat'
  const htmlElement = document.querySelector('html')
  const vatSwitchCheckboxes = document.querySelectorAll(
    '.vat-switch input[type=checkbox]'
  )

  if (vatSwitchCheckboxes.length) {
    vatSwitchCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', function (event) {
        const checked = event.target.checked
        localStorage.setItem(vatLocalStorageKey, checked.toString())
        htmlElement.classList.toggle('include-vat', checked)
        const otherCheckbox = [...vatSwitchCheckboxes].find(
          (checkbox) => checkbox !== this
        )
        otherCheckbox.checked = checked
      })
    })

    document.querySelectorAll('.vat-switch .off').forEach((offSwitch) => {
      offSwitch.addEventListener('click', function () {
        vatSwitchCheckboxes.forEach((vatSwitchCheckbox) => {
          vatSwitchCheckbox.checked = false
          vatSwitchCheckbox.dispatchEvent(new Event('change'))
        })
      })
    })

    document.querySelectorAll('.vat-switch .on').forEach((onSwitch) => {
      onSwitch.addEventListener('click', function () {
        vatSwitchCheckboxes.forEach((vatSwitchCheckbox) => {
          vatSwitchCheckbox.checked = true
          vatSwitchCheckbox.dispatchEvent(new Event('change'))
        })
      })
    })
  }

  getPreferenceFromLocalStorage(vatSwitchCheckboxes, vatLocalStorageKey)
})()

function getPreferenceFromLocalStorage(checkboxes, localStorageKey) {
  const value = localStorage.getItem(localStorageKey)
  if (value === 'false') {
    localStorage.setItem(localStorageKey, 'false')
    checkboxes[0].click()
  } else {
    localStorage.setItem(localStorageKey, 'true')
    document.querySelector('html').classList.add('include-vat')
  }
}
